
import * as defaultImport from "lodash/invert";
export * from "lodash/invert";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
